import {
  Component,
  OnInit,
  ViewChild,
  Renderer2,
  ElementRef,
  OnDestroy,
  SecurityContext,
} from '@angular/core'
import { MatAccordion } from '@angular/material/expansion'
import { CheckoutService } from '../../checkout.service'
import { Router } from '@angular/router'
import { forkJoin, Observable, Subscription } from 'rxjs'
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component'
import { ShipmentMethodComponent } from '../shipment-method/shipment-method.component'
import { NotificationAttachmentComponent } from '../notification-attachment/notification-attachment.component'
import { HostListener } from '@angular/core'
import { filter, take } from 'rxjs/operators'
import { LaunchDialogService } from '@spartacus/storefront'
import { DomSanitizer } from '@angular/platform-browser'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../../../../shared/services/common.service'
import { QuoteCheckoutService } from '../../../../../quote/quote-checkout/services/quote-checkout.service'
import { BreadcrumbService } from '../../../../../../shared/components/breadcrumb/breadcrumb.service'
import { SearchBoxComponentService } from '../../../../../search-box/search-box-component.service'
import { DialogBoxService } from '../../../../../../shared/dialog-box/dialog-box.service'
import { environment } from '../../../../../../../environments/environment'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../../config/dialog.config'

// import { export_questions } from './questions';

export const headerOptions = { responseType: 'text' as 'json' }

@Component({
  standalone: false,
  selector: 'vs-order-checkout',
  templateUrl: './order-checkout.component.html',
  styleUrls: ['./order-checkout.component.scss'],
})
export class OrderCheckoutComponent implements OnInit, OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion
  cartId$: Observable<string> = this.activeCartService.getActiveCartId()

  public disbledBtn = false
  public getMethod
  public isProceedToCheckout = false
  public showContent: boolean
  public toggleAccordion: boolean
  public vsExportComplianceQuestions
  public cartId
  public getErrorBlock
  public getErrorID
  public notificationAllFiles: string[] = []
  public myFiles: string[] = []
  public uploadedFiles: any[] = []
  public totalAllFiles: any = 0
  public hideTrasnportion: boolean
  public getCartReview
  public errorFlag: boolean = false
  warningFlagText = ''
  @ViewChild('fileMaxLenghtExceed', { static: false })
  fileMaxLenghtExceed: ElementRef
  @ViewChild('fileType', { static: false }) fileType: ElementRef
  @ViewChild('fileSizeExceed', { static: false }) fileSizeExceed: ElementRef
  @ViewChild('fileDuplicate', { static: false }) fileDuplicate: ElementRef
  @ViewChild('fileInfo', { static: false }) fileInfo: ElementRef
  @ViewChild('filenameLengthNotify', { static: false })
  filenameLengthNotify: ElementRef
  @ViewChild('shipmentMethodChild') shipmentMethodChild
  @ViewChild('notificationAttachmentChild') notificationAttachmentChild
  @ViewChild('fptError', { read: ElementRef, static: false })
  public fptError: ElementRef
  @ViewChild('exportComplianceError', { read: ElementRef, static: false })
  public exportComplianceError: ElementRef
  @ViewChild('countryErr', { read: ElementRef, static: false })
  public countryErr: ElementRef
  @ViewChild('filenameSpecialcharNotify', { static: false })
  filenameSpecialcharNotify: ElementRef

  cart: any
  productName: any
  prodtotal: any
  prodtotalValue: any
  complianceData: any
  question: any
  activeCart: any
  orderObj: any
  checkoutObj: any
  showQuestionaireSection: any
  purchaseOrderReq: any = ''
  shipingAddress: any
  endUserIndustry: any
  legalEntityData$: Observable<any>
  legalEntityData: any
  shipmentMethod: any
  carrierd: any
  iNCOTerms: any
  freightTerms: any
  userType: string
  orderCheckoutForm: FormGroup
  pageLoadHideErrorMsg = false
  isSelectAddress = false
  sanctionCheckExportCompliance1: any
  restrictedCountryCheckExportCompliance2: any
  restrictedPartListExportCompliance3: any
  warningFlagsExportCompliance4: any
  isNuclearExportCompliance5: any
  hasRestrictedUseExportCompliance6: any
  requiresExportLicenseExportCompliance7: any
  customerReviewCheckExportCompliance8: any
  fetchedCartReviewOrder: any = {}
  endUserCountry: any
  myFilesNotification: string[] = []
  end: any
  carrierDataForm: boolean
  customerDataForm: boolean
  orderAckDataForm: boolean
  shipmentDataForm: boolean
  getLegalQues: any
  quoteCartType: string
  fileClose: any

  partialShipping: boolean

  public partialShippingObj
  exportQuesObj: any

  componentAddress = 'Sold to'
  @ViewChild(CustomerDetailComponent)
  customerDetailComp: CustomerDetailComponent
  @ViewChild(ShipmentMethodComponent)
  shipmentMethodComp: ShipmentMethodComponent
  @ViewChild(NotificationAttachmentComponent)
  notificationAttachmentComp: NotificationAttachmentComponent
  @ViewChild('purchaseOrderNumberError') purchaseOrderNumberError: ElementRef
  getSepcsialInst: any
  cart$: Observable<any>
  //userDetails$: Observable<any>
  cartExportCompResponse: any = []
  displayLoader: boolean = false
  poNumb: any
  activeCartSubscription: Subscription
  cartSubscriptionForPartial: Subscription
  activeCartSubscriptionForCartId: Subscription
  activeCartSubscriptionForPartial: Subscription

  goneThroughValidationScroll: boolean = false
  //userSapBlocked: boolean = false

  cartName = 'vscart'
  attachmentsCount = 0
  governmentPartiesExportCompliance9: any
  checkboxData: boolean
  restrictedCountryFlag: boolean
  autoFillFlag: boolean
  specialChar = /[`!@#$%^&*(){}.;,~]/
  constructor(
    private launchDialogService: LaunchDialogService,
    public activeCartService: ActiveCartFacade,
    private checkoutService: CheckoutService,
    private commonService: CommonService,
    private router: Router,
    private quoteCheckoutService: QuoteCheckoutService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private breadCrumbService: BreadcrumbService,
    private elRef: ElementRef,
    private globalMessageService: GlobalMessageService,
    private translate: TranslationService,
    private searchBoxComponentService: SearchBoxComponentService,
    private dialogBoxService: DialogBoxService,
    private domSanitizer: DomSanitizer
  ) {
    this.showContent = false
    this.toggleAccordion = true
    this.hideTrasnportion = false
    this.checkoutService.reciveCheckboxData.subscribe((data) => {
      this.checkboxData = data
    })
  }

  ngOnInit(): void {
    this.orderCheckoutForm = this.formBuilder.group({
      purchaseOrderNumber: new FormControl('', [
        this.poIbsValidator.bind(this),
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9- ]+$'),
      ]),
    })

    this.checkoutService.receiveSpcailInsOthers.subscribe((success) => {
      this.getSepcsialInst = success
    })

    //this.userDetails$ = this.getCustomerData();

    this.translate.translate('orderCheckOut.shpCart').subscribe((res: string) =>
      this.breadCrumbService.setBreadCrumbs([
        {
          label: res,
          link: '/cart',
        },
      ])
    )

    this.translate
      .translate('orderCheckOut.odrCheckout')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.checkoutService.receivecarrierDataForm.subscribe((valid) => {
      this.carrierDataForm = valid
    })

    this.checkoutService.getEndCustomerAddData.subscribe((data) => {
      this.endUserCountry = data?.country?.isocode
    })

    this.checkoutService.receivecustomerDataForm.subscribe((valid) => {
      this.customerDataForm = valid
    })
    this.checkoutService.receiveorderAckDataForm.subscribe((valid) => {
      this.orderAckDataForm = valid
    })
    this.checkoutService.receiveshipmentDataForm.subscribe((valid) => {
      this.shipmentDataForm = valid
    })
    this.checkoutService.getEndCustomerAddData.subscribe((end) => {
      this.end = end
    })
    this.checkoutService.reciveCartAttachments.subscribe((attachments) => {
      if (attachments) {
        this.cart.attachments = attachments
      }
    })
    this.checkoutService.getLoggedInUserData()

    this.activeCartSubscriptionForCartId = this.cartId$.subscribe(
      (data) => {
        this.checkoutService.getCartIdResponse.next(data)
        if (data) {
          this.cartId = data
          this.cart$ = this.checkoutService.getCart(this.cartId)
          this.cart$.subscribe(
            (response) => {
              this.cart = response
              this.cart.entries.map((entry, index) => {
                if (
                  entry?.stockAvailability === false &&
                  !entry?.quoteCartEntryType
                ) {
                  this.globalMessageService.add(
                    {
                      key: 'orderCheckOut.itemIndexNotAvailableOnRequestedDate',
                      params: { index: parseInt(index + 1) },
                    },
                    GlobalMessageType.MSG_TYPE_ERROR,
                    10000
                  )
                  this.router.navigate(['cart'])
                  return
                }
              })
              this.warningFlagText = this.cart?.warningFlagText || ''
              this.cartExportCompResponse = response
              this.checkoutService.getCartServerResponse.next(response)
              this.checkoutService.billToAddressData.next(
                this.cart?.billToAddress
              )
              this.orderCheckoutForm.controls['purchaseOrderNumber'].setValue(
                this.cart?.purchaseOrderNumber
              )

              if (this.cart?.purchaseOrderNumber) {
                this.checkoutService.onPurchaseOrderReqData.next(
                  this.cart.purchaseOrderNumber
                )
              }

              this.fetchedCartReviewOrder = response

              this.quoteCartType = response['quoteCartType']
              sessionStorage.setItem('quoteCartType', response['quoteCartType'])
              this.endUserCountry = this.checkoutService.endCustomerAddressData
              sessionStorage.setItem('isRfqCart', response['isRfqCart'])
              if (
                this.quoteCartType != null &&
                this.quoteCartType != undefined &&
                !response['isRfqCart']
              ) {
                this.globalMessageService.add(
                  { key: 'orderCheckOut.convertThisQuote' },
                  GlobalMessageType.MSG_TYPE_INFO,
                  10000
                )
              }

              this.checkoutService.orderpreferences.next(this.cart)
              this.fetchedCartReviewOrder = response

              this.quoteCartType = response['quoteCartType']
              this.endUserCountry = this.checkoutService.endCustomerAddressData
            },
            (error) => {
              // this.globalMessageService.add(
              //   error,
              //   GlobalMessageType.MSG_TYPE_ERROR,
              //   5000
              // );
              // window.scrollTo(0, 0);
            }
          )

          this.getPartialShipping()
        }
      },
      (error) => {
        // this.globalMessageService.add(
        //   error,
        //   GlobalMessageType.MSG_TYPE_ERROR,
        //   5000
        // );
        // window.scrollTo(0, 0);
      }
    )

    this.checkoutService.orderpreferences.subscribe(
      (data) => {
        this.exportQuesObj = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.activeCartSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe((successCartID) => {
        this.checkoutService.getComplianceQues(this.cartId).subscribe(
          (success) => {
            this.vsExportComplianceQuestions = success
            this.complianceData = success

            if (this.exportQuesObj) {
              for (let i = 0; i < this.exportQuesObj.length; i++) {
                for (
                  let j = 0;
                  j < this.vsExportComplianceQuestions.length;
                  j++
                ) {
                  this.vsExportComplianceQuestions[i].errorCompliancecMsg =
                    false
                  if (
                    this.vsExportComplianceQuestions[i].questionId ==
                    this.exportQuesObj[j]
                  ) {
                    this.vsExportComplianceQuestions[i].selected = true
                  } else {
                    this.vsExportComplianceQuestions[i].selected = false
                  }
                }
              }
            } else {
              for (
                let i = 0;
                i < this.vsExportComplianceQuestions.length;
                i++
              ) {
                this.vsExportComplianceQuestions[i].selected = false
              }
            }

            for (let exportObj of success['vsExportComplianceQuestions']) {
              this.updateQuestionaire(
                exportObj.answerOption,
                exportObj.questionId
              )
            }
          },
          (error) => {
            // this.globalMessageService.add(
            //   error,
            //   GlobalMessageType.MSG_TYPE_ERROR,
            //   5000
            // );
            window.scrollTo(0, 0)
          }
        )
      })
    this.orderCheckoutForm.valueChanges.subscribe(
      (data) => {
        this.checkoutService.sendCarrierdataForm(this.orderCheckoutForm.valid)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.checkoutService.getComplianceQuesLegal().subscribe(
      (success) => {
        this.getLegalQues = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.checkoutService.orderSubmittedStatus.next(false)

    // this.userDetails$.subscribe((res) => {
    //   this.userSapBlocked = (res?.orgUnit?.sapBlocked == "true") ? true : false;
    // });
  }

  // getCustomerData() {
  //   const params = ['users', 'current', 'myprofile']
  //   const apiUrl = this.commonService.constructUrl(params)
  //   return this.commonService.getData(apiUrl)
  // }

  getNotifyFiles(event) {
    this.notificationAllFiles = event
  }

  get formControls() {
    return this.orderCheckoutForm.controls
  }

  expandAll() {
    this.toggleAccordion = true
  }

  collapseAll() {
    this.toggleAccordion = false
  }

  onPurchaseOrderReqChange(event) {
    this.poNumb = event.target.value
    this.checkoutService.onPurchaseOrderReqData.next(event.target.value)
  }

  checkForExportComplianceMandateFlag: boolean = false
  checkForExportComplianceMandateStatus() {
    // if (
    //   this.endUserCountry !==
    //   this.getLegalQues?.salesAreaAddress?.country?.isocode
    // ) {

    for (let data of this.complianceData?.vsExportComplianceQuestions) {
      let qId = data.questionId
      if (this.cartExportCompResponse[qId] === undefined) {
        return false
      }
    }
    return true
    // } else {
    //   return true;
    // }
  }

  checkEndUserAddressLogic() {
    let returnObj = this.formatAddressData(this.end)
    if (returnObj !== undefined && returnObj !== '') {
      if (
        returnObj['country'] !== undefined &&
        returnObj['country'].isocode === undefined
      ) {
        return false
      }
    }
    return true
  }

  proceedToReview() {
    let soldTo = this.checkoutService.billToAddressData.getValue()
    let shipTo = this.checkoutService.deliveryAddressData.getValue()
    let endUser = this.checkoutService.endCustomerAddressData.getValue()
    this.isProceedToCheckout = true
    this.pageIsManuallyScrolled = false
    this.shipmentMethodChild.checkValidateTextArea()
    this.notificationAttachmentChild.checkValidateTextAreaCsr()
    if (
      soldTo.country.isocode == 'RU' ||
      shipTo.country.isocode == 'RU' ||
      endUser.country.isocode == 'RU'
    ) {
      const componentdata = {}

      const warningDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.WARNING_DIALOG,
        undefined,
        undefined,
        componentdata
      )
      if (warningDialog) {
        warningDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose.subscribe((value) => {})
      }
    } else if (
      this.carrierDataForm &&
      this.customerDataForm &&
      this.orderAckDataForm &&
      this.checkForExportComplianceMandateStatus() &&
      this.checkEndUserAddressLogic()
    ) {
      if (!this.cart.isConsolidatedShipment && this.shipmentDataForm) {
        this.managePostRequests()
      }
      if (this.cart?.isConsolidatedShipment == true) {
        this.managePostRequests()
      }
    }

    // if (this.quoteCartType) {
    //   this.managePostRequests();
    // }
  }

  managePostRequests() {
    const requestslist = []
    this.displayLoader = true
    window.scrollTo(0, 0)
    requestslist.push(this.postSaveOrderPreferences())
    requestslist.push(this.postSavePODetails())
    requestslist.push(this.postShippingInstructions())

    forkJoin(requestslist).subscribe(
      (response) => {
        if (response[0]) {
          this.getCartReview = response[0]
          this.checkoutService.sendCartReview(this.getCartReview)
        }
        this.checkoutService.sendCheckboxFlag(false)
        this.checkboxData = false
        this.router.navigate(['/cart/review'])
        // this.displayLoader = false;
      },
      (error) => {
        //this.displayLoader = false;

        this.globalMessageService.add(
          { key: 'orderCheckOut.issueWhileCheckout' },
          GlobalMessageType.MSG_TYPE_ERROR,
          8000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  postShippingInstructions() {
    const url =
      environment.occBaseUrl +
      '/occ/v2/vsstore/users/' +
      'current' +
      '/vscart/' +
      this.cartId +
      '/saveSpecialInstructions'

    let params = []

    if (this.checkoutService.specialdocSIData.getValue().selected) {
      params.push(this.checkoutService.specialdocSIData.getValue())
    }

    if (this.checkoutService.finaltestSIData.getValue().selected) {
      params.push(this.checkoutService.finaltestSIData.getValue())
    }

    if (this.checkoutService.valvesdimenSIData.getValue().selected) {
      params.push(this.checkoutService.valvesdimenSIData.getValue())
    }

    if (this.checkoutService.othersSIData.getValue().selected) {
      params.push(this.checkoutService.othersSIData.getValue())
    }

    if (this.checkoutService.inspectionTestSIData.getValue().selected) {
      params.push(this.checkoutService.inspectionTestSIData.getValue())
    }

    if (this.checkoutService.cMTRSSIData.getValue().selected) {
      params.push(this.checkoutService.cMTRSSIData.getValue())
    }

    if (this.checkoutService.iNstructionSIData.getValue().selected) {
      params.push(this.checkoutService.iNstructionSIData.getValue())
    }

    if (this.checkoutService.witnessInspctnData.getValue().selected) {
      params.push(this.checkoutService.witnessInspctnData.getValue())
    }

    if (this.checkoutService.certificateOriginData.getValue().selected) {
      params.push(this.checkoutService.certificateOriginData.getValue())
    }

    if (this.checkoutService.cooStampData.getValue().selected) {
      params.push(this.checkoutService.cooStampData.getValue())
    }

    if (this.checkoutService.certificateConformanceData.getValue().selected) {
      params.push(this.checkoutService.certificateConformanceData.getValue())
    }

    if (this.checkoutService.certificateManufactureData.getValue().selected) {
      params.push(this.checkoutService.certificateManufactureData.getValue())
    }

    if (this.checkoutService.warrantyCertificateData.getValue().selected) {
      params.push(this.checkoutService.warrantyCertificateData.getValue())
    }

    if (this.checkoutService.bankGuaranteeData.getValue().selected) {
      params.push(this.checkoutService.bankGuaranteeData.getValue())
    }
    if (params.length === 0) {
      params = []
    } else {
      this.convertShippingInstructions({ specialInstructionsList: params })
    }

    return this.commonService.postData(url, {
      specialInstructionsList: params,
    })
  }

  postSaveOrderPreferences() {
    const url =
      environment.occBaseUrl +
      '/occ/v2/vsstore/users/' +
      'current' +
      '/vscart/' +
      this.cartId +
      '/cartReview'

    if (
      this.fetchedCartReviewOrder?.cartOrderType?.code === 'STK' ||
      this.fetchedCartReviewOrder?.rfqType === 'STK'
    ) {
      this.end = this.checkoutService.endCustomerAddressData.getValue()
    }
    this.checkoutObj = {
      code: this.checkoutService.cartId,
      sanctionCheck: this.sanctionCheckExportCompliance1,
      restrictedCountryCheck: this.restrictedCountryCheckExportCompliance2,
      restrictedPartList: this.restrictedPartListExportCompliance3,
      warningFlags: this.warningFlagsExportCompliance4,
      isNuclear: this.isNuclearExportCompliance5,
      hasRestrictedUse: this.hasRestrictedUseExportCompliance6,
      requiresExportLicense: this.requiresExportLicenseExportCompliance7,
      customerReviewCheck: this.customerReviewCheckExportCompliance8,
      governmentParties: this.governmentPartiesExportCompliance9,
      warningFlagText: this.warningFlagText,
      specialInstructionText: this.getSepcsialInst,

      billToAddress: this.formatAddressData(
        this.checkoutService.billToAddressData.getValue()
      ),
      deliveryAddress: this.formatAddressData(
        this.checkoutService.deliveryAddressData.getValue()
      ),
      endUserAddress: this.formatAddressData(this.end),
      endUserIndustry: this.checkoutService.endUserIndustryData.getValue(),
      endUserIndustryCode: this.checkoutService.endUserIndustryData.getValue(),
      freightAccountNumber:
        this.checkoutService.freightTermsAccNoData.getValue(),
      freightTerm: this.checkoutService.freightTermsData.getValue(),
      incoTerms: this.checkoutService.iNCOTermsData.getValue(),
      shipInstructions: this.checkoutService.shipingInstrctnData.getValue(),
      shippingMarks: this.checkoutService.shipingMarksData.getValue(),

      shipmentMethod: this.checkoutService.shipmentMethodData.getValue(),
      shipmentMethodCode: this.checkoutService.shipmentMethodData.getValue(),
      //  rfqType: 'STOCK', //temparary hard coaded
      rfqType: this.fetchedCartReviewOrder.cartOrderType.code,
      //     legalEntity: '9090', //temparary hard coaded
      legalEntity:
        this.getLegalQues?.code || this.fetchedCartReviewOrder?.legalEntity,
    }

    this.convertOrderPreferences(this.checkoutObj)

    // this.commonService.postData(url, this.checkoutObj).pipe(take(1), share())
    // .subscribe((success) => {
    //   this.getCartReview = success;
    //   this.checkoutService.sendCartReview(this.getCartReview);
    // }, (error) => {
    //   this.globalMessageService.add(
    //     error,
    //     GlobalMessageType.MSG_TYPE_ERROR,
    //     5000
    //   );
    //   window.scrollTo(0, 0);
    // });

    return this.commonService.postData(url, this.checkoutObj, headerOptions)
  }

  postSavePODetails() {
    const url =
      environment.occBaseUrl +
      '/occ/v2/vsstore/users/' +
      'current' +
      '/vscart/' +
      this.cartId +
      '/cartReviewAttachments'

    const notificationValues = {
      orderAckEmail: this.checkoutService.onorderAckEmailData.getValue(),
      /*  invoiceEmail:" ",
      shipNotificationEmail:" ", */
      invoiceEmail: this.checkoutService.oninvoiceEmailData.getValue(),
      shipNotificationEmail:
        this.checkoutService.onshipNotificationEmailData.getValue(),
      csrReviewReason: this.checkoutService.reasonForCsrReviewData.getValue(),
      csrReviewNeeded: this.checkoutService.reviewConditionData.getValue(),
      poNumber: this.checkoutService.onPurchaseOrderReqData.getValue(),
    }
    const formData = new FormData()

    formData.append(
      'orderAckEmail',
      this.checkoutService.onorderAckEmailData.getValue()
    )
    /* Business requirement to remove invoiceEmail and shipNotificationEmail
    formData.append(
      'invoiceEmail',
      this.checkoutService.oninvoiceEmailData.getValue()
    );
    formData.append(
      'shipNotificationEmail',
      this.checkoutService.onshipNotificationEmailData.getValue()
    ); */

    formData.append(
      'csrReviewReason',
      this.checkoutService.reasonForCsrReviewData.getValue()
    )

    for (let j = 0; j < this.myFiles.length; j++) {
      formData.append('multipartFile', this.myFiles[j])
    }
    //order checkout lower region upload ends

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.notificationAllFiles.length; i++) {
      formData.append('multipartFiles', this.notificationAllFiles[i])
    }

    formData.append(
      'csrReviewNeeded',
      this.checkoutService.reviewConditionData.getValue().toString()
    )

    // this.checkoutService.onPurchaseOrderReqData.getValue()

    formData.append(
      'poNumber',
      this.checkoutService.onPurchaseOrderReqData.getValue()
    )

    formData.append('paymentTerms', '')
    //this.convertPODetails(formData);
    this.convertPODetails(notificationValues)

    return this.commonService.postData(url, formData)
  }

  formatAddressData(obj: any) {
    if (obj !== undefined) {
      return {
        companyName: obj?.companyName,
        country: {
          isocode: obj?.country?.isocode,
          name: obj?.country?.name,
        },
        defaultAddress: obj?.defaultAddress,
        email: obj?.email,
        firstName: obj?.firstName,
        formattedAddress: obj?.formattedAddress,
        id: obj?.id,
        lastName: obj?.lastName,
        line1: obj?.line1,
        line2: obj?.line2,
        partnerNumber: obj?.partnerNumber,
        postalCode: obj?.postalCode,
        ...(obj.region && {
          region: {
            isocode: obj?.region?.isocode,
            name: obj?.region?.name,
          },
        }),
        shippingAddress: obj?.shippingAddress,
        title: obj?.title,
        titleCode: obj?.titleCode,
        town: obj?.town,
        visibleInAddressBook: obj?.visibleInAddressBook,
        saveForFuture: obj?.saveForFuture,
        sendNewAddressEmail: obj?.sendNewAddressEmail,
      }
    } else {
      return ''
    }
  }

  getLegalEntity() {
    const legalEntity = 'legalEntity'
    this.userType = 'current'
    this.legalEntityData$ = this.quoteCheckoutService.getLegalEntity(
      this.userType
    )
    this.legalEntityData$.subscribe(
      (data: any) => {
        this.legalEntityData = data[legalEntity]
      },
      (error) => {
        // this.globalMessageService.add(
        //   error,
        //   GlobalMessageType.MSG_TYPE_ERROR,
        //   5000
        // );
        window.scrollTo(0, 0)
      }
    )
  }
  autoFill(list) {
    const componentdata = {}

    const autoFillNoDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.AUTOFILL_NO,
      undefined,
      undefined,
      componentdata
    )
    if (autoFillNoDialog) {
      autoFillNoDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.AUTOFILL_NO
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'confirm-autofill') {
            this.dialogBoxService.autoFillData.next(true)
            for (let exportObj of list) {
              this.updateQuestionaire(false, exportObj.questionId)
            }
          }
        })
    }
  }
  updateQuestionaire(value, id) {
    this.cartExportCompResponse[id] = value
    for (
      var i = 0;
      i < this.complianceData.vsExportComplianceQuestions.length;
      i++ // if (this.complianceData.vsExportComplianceQuestions[i].questionId == id) { //   this.complianceData.vsExportComplianceQuestions[i].errorCompliancecMsgShow = false; // }
    ) {
      if (id == 'sanctionCheck' && (value == 'true' || value == true)) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].errorCompliancecMsg = true
          this.errorFlag = true
          this.checkoutService.sendErrorFlag(this.errorFlag)
        }
      } else if (
        id == 'sanctionCheck' &&
        (value == 'false' || value == false)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].errorCompliancecMsg = false
          this.errorFlag = false
          this.checkoutService.sendErrorFlag(this.errorFlag)
        }
      } else if (
        id == 'requiresExportLicense' &&
        (value == 'true' || value == true)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].requiresExportLicenseWarning = true
          this.errorFlag = false
          // this.checkoutService.sendErrorFlag(this.errorFlag);
        }
      } else if (
        id == 'requiresExportLicense' &&
        (value == 'false' || value == false)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].requiresExportLicenseWarning = false
          this.errorFlag = false
          // this.checkoutService.sendErrorFlag(this.errorFlag);
        }
      } else if (
        id == 'hasRestrictedUse' &&
        (value == 'true' || value == true)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].hasRestrictedUseWarning = true
          this.errorFlag = false
          // this.checkoutService.sendErrorFlag(this.errorFlag);
        }
      } else if (
        id == 'hasRestrictedUse' &&
        (value == 'false' || value == false)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].hasRestrictedUseWarning = false
          this.errorFlag = false
          // this.checkoutService.sendErrorFlag(this.errorFlag);
        }
      } else if (
        id == 'governmentParties' &&
        (value == 'true' || value == true)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].governmentPartiesFlag = true
          this.errorFlag = true
          this.attachmentsCount++
          this.checkoutService.sendCountFiles(this.attachmentsCount)
        }
      } else if (
        id == 'governmentParties' &&
        (value == 'false' || value == false)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].governmentPartiesFlag = false
          this.errorFlag = false

          if (this.attachmentsCount > 0) {
            this.attachmentsCount--
          }
          this.checkoutService.sendCountFiles(this.attachmentsCount)
        }
      } else if (
        id == 'restrictedPartList' &&
        (value == 'true' || value == true)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].restrictedPartListFlag = true
          this.errorFlag = true
          this.attachmentsCount++

          this.checkoutService.sendCountFiles(this.attachmentsCount)
        }
      } else if (
        id == 'restrictedPartList' &&
        (value == 'false' || value == false)
      ) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[
            i
          ].restrictedPartListFlag = false
          this.errorFlag = false
          //this.attachmentsCount--;
          if (this.attachmentsCount > 0) {
            this.attachmentsCount--
          }

          this.checkoutService.sendCountFiles(this.attachmentsCount)
        }
      } else if (id == 'warningFlags' && (value == 'true' || value == true)) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[i].warningMsgFlags =
            true
          if (this.warningFlagText == '') {
            this.errorFlag = true
          } else {
            this.errorFlag = false
          }
        }
      } else if (id == 'warningFlags' && (value == 'false' || value == false)) {
        if (
          id == this.complianceData.vsExportComplianceQuestions[i].questionId
        ) {
          this.complianceData.vsExportComplianceQuestions[i].warningMsgFlags =
            false
          this.errorFlag = false
          this.warningFlagText = ''
        }
      }
    }
    switch (id) {
      case 'sanctionCheck':
        this.sanctionCheckExportCompliance1 = value
        break
      case 'restrictedCountryCheck':
        this.restrictedCountryCheckExportCompliance2 = value
        break
      case 'restrictedPartList':
        this.restrictedPartListExportCompliance3 = value
        break
      case 'warningFlags':
        this.warningFlagsExportCompliance4 = value
        break
      case 'isNuclear':
        this.isNuclearExportCompliance5 = value
        break
      case 'hasRestrictedUse':
        this.hasRestrictedUseExportCompliance6 = value
        break
      case 'requiresExportLicense':
        this.requiresExportLicenseExportCompliance7 = value
        break
      case 'customerReviewCheck':
        this.customerReviewCheckExportCompliance8 = value
        break
      case 'governmentParties':
        this.governmentPartiesExportCompliance9 = value
        break
    }

    this.getErrorBlock = value
    this.getErrorID = id
  }

  upload(event) {
    let _this = this
    let filesTotal = 0
    let totalUploadedFiles = 0
    let totalFileSize = 0
    let prevFiles: any = 0

    this.fileMaxLenghtExceed.nativeElement.innerHTML = ''
    this.fileType.nativeElement.innerHTML = ''
    this.fileSizeExceed.nativeElement.innerHTML = ''
    this.fileDuplicate.nativeElement.innerHTML = ''
    this.filenameLengthNotify.nativeElement.innerHTML = ''
    this.filenameSpecialcharNotify.nativeElement.innerHTML = ''
    const uploadDiv = this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.fileInfo.nativeElement
    )
    const uploadedFilesCount = document.querySelectorAll('.fileDivID-section')

    let isDuplicateFiles = false
    let allFileNames = []
    for (let j = 0; j < uploadedFilesCount.length; j++) {
      let size = parseInt(uploadedFilesCount[j].getAttribute('data-size'))
      allFileNames.push(uploadedFilesCount[j].getAttribute('data-filename'))
      prevFiles = prevFiles + size
    }
    let totalSize = prevFiles

    if (
      event.target.files.length <= 1 &&
      event.target.files.length + uploadedFilesCount.length <= 1
    ) {
      if (
        event.target.files.length == 1 ||
        event.target.files.length + uploadedFilesCount.length == 1
      ) {
        this.disbledBtn = true
      }

      for (let a = 0; a < event.target.files.length; a++) {
        totalSize += event.target.files[a].size
        allFileNames.forEach((file) => {
          if (event.target.files[a].name == file) {
            this.fileDuplicate.nativeElement.innerHTML = 'File Already exists'
            isDuplicateFiles = true
          }
        })
      }

      let filesMB = Math.round((totalSize / (1024 * 1024)) * 100) / 100 // in MB
      if (filesMB <= 5) {
        if (!isDuplicateFiles) {
          for (let i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i].name.trim().length > 30) {
              this.filenameLengthNotify.nativeElement.innerHTML =
                'File name length should not be greater than 30 characters'
              this.disbledBtn = false
              return
            }
            let res_field = event.target.files[i].name
            let extension = res_field
              .substr(res_field.lastIndexOf('.') + 1)
              .toLowerCase()
            let allowedExtensions = [
              // 'xlsx',
              'doc',
              'jpg',
              'png',
              'pdf',
              'jpeg',
            ]
            totalSize += event.target.files[i].size
            let file_name = event.target.files[i].name.substring(
              0,
              event.target.files[i].name.lastIndexOf('.')
            )
            if (this.specialChar.test(file_name)) {
              this.filenameSpecialcharNotify.nativeElement.innerHTML =
                'File name should not contain any of the following special characters !@#$%^&*(){}.;,~'
              this.disbledBtn = false
              return
            }

            if (allowedExtensions.indexOf(extension) === -1) {
              this.fileType.nativeElement.innerHTML =
                //document.getElementById('fileType').innerText =
                'File format is not supported'
              this.disbledBtn = false
            } else {
              this.uploadedFiles.push({
                filename: event.target.files[i].name,
                filesize: event.target.files[i].size,
              })
              const fileDiv = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('div')
              )
              this.renderer.appendChild(uploadDiv, fileDiv)
              this.renderer.setAttribute(fileDiv, 'id', 'fileDivID')
              this.renderer.setAttribute(
                fileDiv,
                'data-size',
                event.target.files[i].size
              )
              this.renderer.setAttribute(
                fileDiv,
                'data-filename',
                event.target.files[i].name
              )
              this.renderer.addClass(fileDiv, 'fileDivID-section')
              const fileIcon = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('i')
              )
              this.renderer.appendChild(fileDiv, fileIcon)
              this.renderer.addClass(fileIcon, 'material-icons')
              this.renderer.addClass(fileIcon, 'material-icons-custom')
              const iconText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('receipt')
              )
              this.renderer.appendChild(fileIcon, iconText)
              const fileName = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDiv, fileName)
              this.renderer.setAttribute(fileName, 'id', 'para11')
              const fileNameText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(event.target.files[i].name)
              )
              this.renderer.appendChild(fileName, fileNameText)
              const fileSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDiv, fileSize)
              this.renderer.setAttribute(fileSize, 'id', 'para22')
              const fileNameSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(
                  // 'Size: ' + Math.round(event.target.files[i].size / 1024) + 'KB'
                  ' ' + this.getFileSize(event.target.files[i].size)
                )
              )
              this.renderer.appendChild(fileSize, fileNameSize)
              const closeIcon = this.renderer.createElement('span')
              this.renderer.appendChild(fileDiv, closeIcon)
              this.renderer.setAttribute(closeIcon, 'id', `${i}`)
              this.renderer.setAttribute(
                closeIcon,
                'data-name',
                event.target.files[i].name
              )
              this.renderer.addClass(closeIcon, 'closeId-img')
              const fileNameClose = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('X')
              )
              this.renderer.appendChild(closeIcon, fileNameClose)
              closeIcon.addEventListener('click', function (evt) {
                _this.disbledBtn = false
                this.parentElement.remove()
                if (_this.fileMaxLenghtExceed) {
                  _this.fileMaxLenghtExceed.nativeElement.innerHTML = ' '
                }

                for (let z = 0; z < totalUploadedFiles; z++) {
                  if (
                    this.getAttribute('data-name') ==
                    _this.uploadedFiles[z].filename
                  ) {
                    prevFiles = 0

                    _this.uploadedFiles.splice(z, 1)
                    totalUploadedFiles = totalUploadedFiles - 1
                    _this.myFiles.splice(z, 1)
                  }
                }
              })
              this.myFiles.push(event.target.files[i])
              totalUploadedFiles = totalUploadedFiles + 1
            }
          } // for ends
        } else {
          this.fileDuplicate.nativeElement.innerHTML = 'File already exists'
        }
      } else {
        this.fileSizeExceed.nativeElement.innerHTML =
          'File size should not be greater than 5 MB'
        this.disbledBtn = false
      }
    } else {
      this.fileMaxLenghtExceed.nativeElement.innerHTML =
        'You have exceeded files'
    }
    event.target.value = ''
  }
  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed(2) + ' kb'
    }
  }
  tranportaionData(event) {
    this.hideTrasnportion = event
  }

  printShippingMethod() {
    if (this.partialShipping) {
      return 'Partial'
    } else {
      return 'Complete'
    }
  }

  convertFileRetain(data) {
    let returnVal
    returnVal = (data / (1024 * 1024)).toFixed(2)
    if (returnVal > 1) {
      return returnVal + 'mb'
    } else {
      return (data / 1024).toFixed(2) + 'kb'
    }
  }

  closeFile(event, mediaFile) {
    const urlparams = [
      'users',
      'current',
      'vscart',
      this.checkoutService.cartId,
      'removeAttachment',
    ]
    const apiUrl = this.commonService.constructUrl(urlparams)
    this.commonService
      .postData(apiUrl + '?' + 'mediaId=' + mediaFile, {})
      .subscribe((success) => {
        for (let i = 0; i < this.cart.poAttachments.length; i++) {
          if (mediaFile === this.cart.poAttachments[i].mediaCode) {
            this.cart.poAttachments.splice(i, 1)
          }
        }
        event.target.parentNode.innerHTML = ''
        this.fileClose = success
      })
  }

  getPartialShipping() {
    this.activeCartSubscriptionForPartial = this.activeCartService
      .getActiveCartId()
      .subscribe((cartId) => {
        if (cartId) {
          this.cartSubscriptionForPartial =
            this.checkoutService.getCartServerResponse.subscribe((response) => {
              this.partialShippingObj = response
              this.partialShipping = this.partialShippingObj?.partialShipping
            })
        }
      })
  }

  editCartLink() {
    this.router.navigate(['/cart'])
  }

  convertOrderPreferences(value) {
    return this.getOrderPreferences(value)
  }

  convertPODetails(value) {
    return this.getPODetails(value)
  }

  convertShippingInstructions(value) {
    return this.getShippingInstructions(value)
  }

  getOrderPreferences(value) {
    this.checkoutService.orderpreferences.next(value)
  }

  getPODetails(value) {
    this.checkoutService.podetails.next(value)
  }

  getShippingInstructions(value) {
    this.checkoutService.shippinginstructions.next(value)
  }

  scrollToElRef(el, scrollAdjust = -150) {
    el.nativeElement.focus()
    el.nativeElement.scrollIntoView()
    window.scrollBy(0, scrollAdjust)
  }

  manageValidationScroll() {
    if (
      this.customerDetailComp !== undefined &&
      this.customerDetailComp['endUseIndustryError'] !== undefined
    ) {
      this.scrollToElRef(this.customerDetailComp['endUseIndustryError'], -400)
      this.goneThroughValidationScroll = true
      return
    } else if (
      this.shipmentMethodComp !== undefined &&
      this.shipmentMethodComp['shipmentMethodError'] !== undefined
    ) {
      this.scrollToElRef(this.shipmentMethodComp['shipmentMethodError'], -200)
      this.goneThroughValidationScroll = true
      return
    } else if (
      this.shipmentMethodComp !== undefined &&
      this.shipmentMethodComp['freightAccNoError'] !== undefined
    ) {
      this.scrollToElRef(this.shipmentMethodComp['freightAccNoError'], -300)
      this.goneThroughValidationScroll = true
      return
    } else if (
      this.shipmentMethodComp !== undefined &&
      this.shipmentMethodComp['shipingInstructionsError'] !== undefined
    ) {
      this.scrollToElRef(
        this.shipmentMethodComp['shipingInstructionsError'],
        -400
      )
      this.goneThroughValidationScroll = true
      return
    } else if (this.exportComplianceError !== undefined) {
      this.scrollToElRef(this.exportComplianceError, -500)
      this.goneThroughValidationScroll = true
      return
    } else if (this.fptError !== undefined) {
      this.scrollToElRef(this.fptError, -100)
      this.goneThroughValidationScroll = true
      return
    } else if (
      this.notificationAttachmentComp !== undefined &&
      this.notificationAttachmentComp['orderAckEmailError'] !== undefined
    ) {
      this.scrollToElRef(this.notificationAttachmentComp['orderAckEmailError'])
      this.goneThroughValidationScroll = true
      return
    } else if (
      /* Business requirement to remove invoiceEmail and shipNotificationEmail
     else if (
      this.notificationAttachmentComp !== undefined &&
      this.notificationAttachmentComp['invoiceEmailError'] !== undefined
    ) {
      this.scrollToElRef(this.notificationAttachmentComp['invoiceEmailError']);
      this.goneThroughValidationScroll = true;
      return;
    } else if (
      this.notificationAttachmentComp !== undefined &&
      this.notificationAttachmentComp['shipNotificationEmailError'] !==
      undefined
    ) {
      this.scrollToElRef(
        this.notificationAttachmentComp['shipNotificationEmailError']
      );
      this.goneThroughValidationScroll = true;
      return;
    } */
      this.notificationAttachmentComp !== undefined &&
      this.notificationAttachmentComp['reasonForCsrReviewError'] !== undefined
    ) {
      this.scrollToElRef(
        this.notificationAttachmentComp['reasonForCsrReviewError'],
        -500
      )
      this.goneThroughValidationScroll = true
      return
    } else if (this.purchaseOrderNumberError !== undefined) {
      this.scrollToElRef(this.purchaseOrderNumberError, -50)
      this.goneThroughValidationScroll = true
      return
    }

    this.goneThroughValidationScroll = false
  }

  proceedToCheckoutBtnStatus() {
    // this.customerReviewCheckExportCompliance8 === true
    this.checkboxData = this.checkboxData
    if (
      this.sanctionCheckExportCompliance1 === 'true' ||
      this.sanctionCheckExportCompliance1 === true ||
      this.attachmentsCount >
        (this.notificationAllFiles?.length || 0) +
          (this.cart?.attachments?.length || 0) ||
      (this.warningFlagText == '' &&
        this.warningFlagsExportCompliance4 == true) ||
      (this.warningFlagText == '' &&
        this.warningFlagsExportCompliance4 == 'true') ||
      !(
        (this.restrictedPartListExportCompliance3 !== undefined ||
          this.restrictedPartListExportCompliance3 !== false ||
          this.governmentPartiesExportCompliance9 !== undefined ||
          this.governmentPartiesExportCompliance9 !== false) &&
        (this.checkboxData !== null || this.checkboxData !== false)
      )
    ) {
      // if (
      //   (this.restrictedPartListExportCompliance3 ||
      //     this.governmentPartiesExportCompliance9) &&
      //   this.checkboxData == null
      // ) {
      //   return false;
      // }
      return true //proceedToCheckoutBtnStatus
    } else {
      if (
        (this.checkboxData == false || this.checkboxData == null) &&
        (this.governmentPartiesExportCompliance9 == true ||
          this.restrictedPartListExportCompliance3 == true ||
          this.governmentPartiesExportCompliance9 == 'true' ||
          this.restrictedPartListExportCompliance3 == 'true')
      ) {
        return true
      } else {
        return false
        // if(this.userSapBlocked){
        //   return true
        // } else{
        //   return false // enable
        // }
      }
    }
  }

  ngAfterViewChecked() {
    if (this.isProceedToCheckout && !this.pageIsManuallyScrolled) {
      this.manageValidationScroll()
    }
  }

  ngOnDestroy() {
    this.searchBoxComponentService.inSearchFlowOnly.next(false)
    if (this.activeCartSubscription) {
      this.activeCartSubscription.unsubscribe()
    }
    if (this.cartSubscriptionForPartial) {
      this.cartSubscriptionForPartial.unsubscribe()
    }
    if (this.activeCartSubscriptionForCartId) {
      this.activeCartSubscriptionForCartId.unsubscribe()
    }
    if (this.activeCartSubscriptionForPartial) {
      this.activeCartSubscriptionForPartial.unsubscribe()
    }
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO)

    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)

    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)

    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION)
  }

  getCouponDiscout() {
    if (this.cart?.productCouponDiscount?.value > 0) {
      return this.cart.productCouponDiscount?.formattedValue
    }
    return this.cart?.orderDiscounts?.formattedValue
  }

  pageIsManuallyScrolled: boolean = false
  @HostListener('mousewheel', ['$event'])
  onMousewheel(event) {
    if (this.isProceedToCheckout && this.goneThroughValidationScroll) {
      this.pageIsManuallyScrolled = true
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (
      event.keyCode == 33 ||
      event.keyCode == 34 ||
      event.keyCode == 35 ||
      event.keyCode == 36 ||
      event.keyCode == 38 ||
      event.keyCode == 40
    ) {
      if (this.isProceedToCheckout && this.goneThroughValidationScroll) {
        this.pageIsManuallyScrolled = true
      }
    }
  }

  poIbsValidator(control: FormControl) {
    const po = control.value?.toString().toUpperCase()
    if (
      po !== undefined &&
      this.fetchedCartReviewOrder?.notificationDetails?.paymentTermsCode?.toUpperCase() ===
        'IBS'
    ) {
      if (po.startsWith('ADN') || po.startsWith('PO')) {
        return null
      }
      return {
        ibsPoErrorValue: {
          value: po,
        },
      }
    }
    return null
  }
  selectedAdd(event) {
    this.cart.billToAddress = event
    this.checkoutService.billToAddressData.next(this.cart?.billToAddress)
    if (this.cart?.isCommissionEligible) {
      this.checkoutService
        .getShiptoAndEndUser(this.userType, this.cartId, event?.soldToUnitId)
        .subscribe((success: any) => {
          this.checkoutService.getCartServerResponse.next(success)
          this.checkoutService.endCustomerAddressData.next(
            success?.endUserAddress
          )
        })
    }
    this.closeForm(false)
  }
  closeForm(event) {
    this.isSelectAddress = event
  }
}
